if(window['notifications']){
    // console.log(window['notifications']);
    window['notifications'].forEach(function (notification) {
        // console.log(notification);
        var sticky = $.sticky(
            notification.data.text,
            {
                autoclose : false,
                duplicates: true,
                position: "top-center",
                type: notification.data.class
            }
        );

        $('.st-close[rel=' + sticky.id + ']').click(function() {
            $.ajax({
                type: "POST",
                url: laroute.route('public::notifications::ajax::mark_as_read', {id: notification.id})
            });
        });
    });

    window.Echo.private('App.Models.Users.User.' + window['user_id'])
        .notification(function(notification){
            var sticky = $.sticky(
                notification.text,
                {
                    speed: 'slow',
                    autoclose : false,
                    duplicates: true,
                    position: "top-center",
                    type: notification.class
                }
            );

            $('.st-close[rel=' + sticky.id + ']').click(function() {
                $.ajax({
                    type: "POST",
                    url: laroute.route('public::notifications::ajax::mark_as_read', {id: notification.id})
                });
            });
        });
}